export default "__VITE_ASSET__CGmocu4l__"